/*global scriptLoader, WebView*/

var tree = require("../tree.json") ;

var availableModules = [] ;
tree.children.some(function(child){
    if(child.name === "modules"){
        availableModules = child.children.map(function(c){ return c.name ;}) ;
        return true ;
    }
}) ;

//these modules only exist in their v2 generation (v1 was retired) but keep
//their historical rights/module names — map name -> bundle folder
var V2_ONLY_MODULES = ["dinvoice", "doc", "payslip", "hr"] ;
function moduleFolder(m){
    return V2_ONLY_MODULES.indexOf(m) !== -1 ? m + "_v2" : m ;
}

function getModulesToLoad(user, callback){
    var modulesToLoad = [] ;
    if(user.isPortal){
        window.app.context.api.public.getPortalModule(function(err, modules){
            if(err){ return callback(err) ;}
            modulesToLoad = modules.map(function(m){ return m.module_name ;}) ;
            return callback(null, modulesToLoad) ;
        }) ;
    }else{
        Object.keys(user.rights).forEach(function(right){
            //to access a module the user must have the right group_iz_MODULENAME_module_user
            if(user.rights[right] && /^group_iz_(.+)_module_user$/.test(right)){
                var moduleName = moduleFolder(right.replace(/^group_iz_/, "").replace(/_module_user$/, "").replace(/_/g, "/")) ;
                if(availableModules.indexOf(moduleName) !== -1){
                    modulesToLoad.push(moduleName) ;
                }
            }
        }) ;
        if(user.rights.group_iz_dinvoice_supplier_user && !modulesToLoad.includes("doc_v2")){
            modulesToLoad.push("doc_v2") ;
        }
        if(user.rights.group_iz_hr_doc_user && !modulesToLoad.includes("doc_v2")){
            modulesToLoad.push("doc_v2") ;
        }
        if(user.rights.group_iz_dinvoice_supplier_admin && !modulesToLoad.includes("admin")){
            modulesToLoad.push("admin") ;
        }
        callback(null, modulesToLoad) ;
    }
}

function initLogin(user, callback){

    if(user.lang){
        WebView.i18n.setLang(user.lang.substring(0,2)) ;
    }

    //load the needed module on login
    getModulesToLoad(user, function(err, modulesToLoad){
        if(err){ return callback(err) ;}
        window.app.context.api.db.multiread({
            iz_product_settings: { searchFirst: {} },
            iz_global_settings: {searchFirst: {}},
            iz_timesheet_settings: { searchFirst: {} },
        }, function(err, reads){
            if(err){ return callback(err) ; }
        

            var langs = ["en", "en-US", "en-GB", "vi", "vi-VN"] ;
        
            //load the needed module bundles
            scriptLoader.load(
                [
                ].concat(
                    modulesToLoad.map(function(m, i){
                        //portal path may still deliver retired v1 names — map to v2 folder
                        m = moduleFolder(m) ;
                        modulesToLoad[i] = m ;

                        var jsBundle = {
                            name: "app-module-"+m,
                            type: "js",
                            localPath: m+"_bundle.js"
                        } ;
                        if(m.indexOf("/") !== -1) {
                            return [jsBundle].concat(langs.map(function(lang){
                                return {
                                    name: "app-module-"+m+"-tr-"+lang,
                                    type: "json",
                                    localPath: m.substring(0, m.indexOf("/"))+"/locales/"+lang+".json"
                                } ;
                            })) ;
                        } else{
                            return jsBundle ;
                        }
                    })
                )
            , function(err, results){
                if(err){ return callback(err) ;}
        
                modulesToLoad.forEach(function(m, i){
                    if(m.indexOf("/") !== -1) {
                        langs.forEach(function(l, y){
                            var bundle = results[i][1+y] ;
                            WebView.i18n.addBundle(l, bundle) ;
                        }) ;
                    }
                }) ;
            
                window.app.context.globalSettings = reads.iz_global_settings || {} ;
                
                if(reads.iz_product_settings && reads.iz_product_settings.search_as_table){
                    var schema = WebView.fieldsSchema.getSchema() ;
                    Object.keys(schema).forEach(function(tableName){
                        var table = schema[tableName] ;
                        if(table.columns){
                            table.columns.forEach(function(column){
                                if(column.searchTable === "iz_product_full"){
                                    column.type = "search_popup" ;
                                    column.options = {
                                        searchtable: "iz_product_full",
                                        searchcolumns: [
                                            "default_code",
                                            "full_cate_name",
                                            "family_name",
                                            "name",
                                            "standard_price",
                                            "list_price",
                                        ].join(","),
                                        criterias: [
                                            "default_code",
                                            "name"
                                        ].join(","),
                                        sideView: '<div  class="d-flex flex-column flex-grow-1">'+
                                        '<div>'+
                                        '<h5><span data-bind="default_code"></span> <span data-bind="name"></span></h5>'+
                                        '<h6><span data-bind="full_cate_name"></span></h6>'+
                                        '<div data-show-if="standard_price"><span data-i18n="fields.iz_product_full.standard_price"> </span>: <strong data-bind="standard_price" data-format="float"></strong></div>'+
                                        '<div data-show-if="list_price"><span data-i18n="fields.iz_product_full.list_price"> </span>: <strong data-bind="list_price" data-format="float"></strong></div>'+
                                        '<div class="mt-2 flex-grow" data-bind="html:description"></div>'+
                                        '</div>'+
                                        '</div>'
                                        ,
                                        labelFieldShort: column.labelFieldShort,
                                        searchFilter: column.searchFilter
                                    } ;
                                }
                            }) ;
                        }
                    }) ;
                }

                
                callback() ;
            });
        });
    }) ;
}



module.exports = initLogin ;
